import React from 'react'
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from "recharts";
import { LoadingSpinner } from '../Loader/Loader';

function AreaChartDiv(props) {

  const { dataSet, loading, dataKey, dataValue } = props
  return (
    <>
      {!loading ?<AreaChart
        width={600}
        height={400}
        data={dataSet}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={dataKey} />
        <YAxis />
        <Tooltip />
        <Area type="monotone" dataKey={dataValue} stroke="rgb(206,162,82)" fill="rgba(206,162,82, .3)" />
      </AreaChart>:(
        <div className="d-flex justify-content-center align-items-center" style={{height:400}}>
            <LoadingSpinner />
        </div>
      )}
    </>
  )
}

export default AreaChartDiv
